import state from './module-notification-user-state';
import mutations from './module-notification-user-mutations';
import actions from './module-notification-user-actions';
import getters from './module-notification-user-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
